import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function ArticleGrid() {
  const displayedArticles = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-10">
            <div>
              <p className="text-sm font-medium text-foreground-400 mb-1">
                独家速报 · 热门追踪
              </p>
              <h2 className="text-3xl md:text-4xl font-heading italic font-black text-foreground-950">
                最新大瓜速递
              </h2>
            </div>
            <p className="text-sm text-foreground-500 max-w-md leading-relaxed">
              每日更新不打烊，汇集全网最新最全的娱乐爆料、网红翻车、黑料实锤，
              让你不错过任何一口瓜。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {displayedArticles.map((article, idx) => {
              const categoryInfo = categories.find((c) => c.slug === article.category);
              return (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-colors cursor-pointer flex flex-col"
                >
                  <div className="relative h-[220px] md:h-[250px] overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.imageAlt}
                      title={article.imageAlt}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    {article.isExclusive && (
                      <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
                        独家爆料
                      </span>
                    )}
                  </div>
                  <div className="p-5 flex flex-col gap-3 flex-1">
                    {categoryInfo && (
                      <span className="inline-flex self-start px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-full whitespace-nowrap">
                        {categoryInfo.name}
                      </span>
                    )}
                    <h3 className="text-base md:text-lg font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                      {article.summary}
                    </p>
                    <div className="mt-auto pt-3 flex items-center justify-between text-xs text-foreground-400">
                      <span>{article.author}</span>
                      <span className="flex items-center gap-4">
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line" />
                          {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-chat-3-line" />
                          {article.comments}
                        </span>
                      </span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>

          <div className="mt-10 text-center">
            <Link
              to="/category/redianzonghe"
              className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-lg hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看更多爆料
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}